// Adding locale in this list will hide social login component for that locale
// This object is stored seperately as a common reference for components & test cases
export const localesWithDisabledSocialLogin: Record<string, readonly string[]> = {
  Vistaprint: [
    "ja-JP"
  ]
};
